import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getUserBankAccountsLoadingState = (state: RootState): RootState['sfBankAccounts']['loading'] =>
  state.sfBankAccounts.loading

export const userBankAccountsIsLoading = createSelector(
  getUserBankAccountsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getUserBankAccounts = (state: RootState): RootState['userBankAccounts']['data'] =>
  state.userBankAccounts.data
